import { Question, Segment } from "hp-types";

const checkXYZFilter = (XYZFilter: boolean, question: Question) => {
  return XYZFilter ? true : question.segment !== Segment.XYZ;
};

export default checkXYZFilter;
